import PreferencesPanel from './PreferencesPanel'
export default PreferencesPanel
